import {Flex} from 'antd';
import React from 'react';

import {convertPxToRem} from '../../../../utils/commonFunctions';

const LabelAndCharts: React.FC<React.PropsWithChildren<{title: string}>> = ({
  title,
  children
}) => {
  return (
    <Flex vertical={true} gap={'1rem'} style={{marginTop: convertPxToRem(40)}}>
      <div
        style={{
          font: 'normal normal 600 20px/17px Montserrat',
          letterSpacing: '0px',
          color: '#677489'
          // padding: '1rem 0rem 0rem 0rem'
        }}
      >
        {title}
      </div>
      {children}
    </Flex>
  );
};

export default LabelAndCharts;
